import Vue from 'vue'
import domUtils from 'util/dom-utils'
import submissionStore from 'store/submission-store'
import SubmissionModal from './submission-modal'

const SUBMISSION_MODAL_ID = 'tt-submission-modal'
let wasLoaded = false

export default {
  // If it does not already exist, this creates a div as a descendant of body with
  // an id used for submission-modal. It then mounts the submission-modal component
  // if not already mounted.
  load() {
    return new Promise((resolve) => {
      if (wasLoaded) {
        submissionStore.isOpen = true
        resolve()
      } else if (!document.getElementById(SUBMISSION_MODAL_ID)) {
        domUtils.appendDivToBody(SUBMISSION_MODAL_ID)
        new Vue({
          el: `#${SUBMISSION_MODAL_ID}`,
          render: h => h(SubmissionModal, {
            attrs: { id: SUBMISSION_MODAL_ID }
          }),
          created() {
            submissionStore.isOpen = true
          }
        })
        wasLoaded = true
        resolve()
      } else {
        resolve()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/submission/submission-loader.ts